var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 84,
    height: 93.152,
    viewBox: "0 0 84 93.152",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5595",
    "data-name": "Rectangle 5595",
    width: 84,
    height: 93.152,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_189889",
    "data-name": "Group 189889",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_189888",
    "data-name": "Group 189888",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42957",
    "data-name": "Path 42957",
    d: "M0,53.653q0-14.543,0-29.085A10.007,10.007,0,0,1,8.452,14.325a11.594,11.594,0,0,1,2.125-.088c3.781-.007,7.562,0,11.343,0,1.357,0,1.35-.005,1.356-1.416.008-2.185-.106-4.365.724-6.48A9.819,9.819,0,0,1,32.6.109C41.615.035,50.632.126,59.646,0A6.331,6.331,0,0,1,64.724,2.1C70.746,8.271,76.89,14.329,83.006,20.412a3.132,3.132,0,0,1,.974,2.407C83.957,38.04,83.9,53.262,84,68.483A10.214,10.214,0,0,1,73.68,78.959c-4.1,0-8.208.013-12.312-.035-.632-.007-.671.215-.682.71a26.346,26.346,0,0,1-.267,5.787,10.082,10.082,0,0,1-10.2,7.705q-17.451.006-34.9-.01A56.516,56.516,0,0,1,8.64,92.99,10.005,10.005,0,0,1,.191,84.948,14.242,14.242,0,0,1,0,82.544Q.007,68.1,0,53.653M4.042,53.6h.017c0,9.756.052,19.513-.028,29.268a6.217,6.217,0,0,0,6.3,6.253c13.406-.063,26.813-.023,40.22-.026a6.533,6.533,0,0,0,1.155-.083c2.618-.474,5.027-2.619,5.013-6.489q-.076-21.612-.008-43.224c0-.718-.231-.839-.876-.833q-4.6.044-9.207,0A10.06,10.06,0,0,1,36.459,28.281c-.007-3-.045-6.01.024-9.013.022-.952-.325-1.117-1.16-1.109-3.836.037-7.673.025-11.51.026q-6.59,0-13.18,0a7.94,7.94,0,0,0-2.2.259c-2.874.824-4.387,3.012-4.389,6.376q-.007,14.392,0,28.784m75.92-6.249h.015c0-7.335-.015-14.669.02-22,0-.859-.228-1.082-1.075-1.067-2.972.053-5.945.039-8.917.02A10.093,10.093,0,0,1,59.733,13.992c-.01-3-.031-6.01.021-9.015C59.768,4.186,59.5,4,58.776,4c-8.465.018-16.931-.013-25.4.029a5.836,5.836,0,0,0-5.943,4.943,33.943,33.943,0,0,0-.113,4.348c-.049.722.164.937.9.928,3.2-.039,6.4.024,9.6-.032A3.259,3.259,0,0,1,40.38,15.28q9.605,9.653,19.265,19.25A3.347,3.347,0,0,1,60.711,37.1c-.025,12.278-.008,24.556-.034,36.835,0,.787.17,1.033.995,1.024,4.071-.043,8.142-.017,12.213-.02a5.006,5.006,0,0,0,.963-.071c3.294-.652,5.1-2.868,5.107-6.384.022-7.044.007-14.087.007-21.131m-26.4-12.909L40.574,21.4c-.005.007-.077.053-.077.1,0,2.386-.028,4.773.013,7.158A5.625,5.625,0,0,0,45,34.211c2.821.569,5.7.1,8.562.232M76.877,20.266,63.889,7.16c-.158.063-.125.206-.125.327,0,2.322,0,4.645.015,6.967A5.665,5.665,0,0,0,65.945,18.9a5.629,5.629,0,0,0,3.726,1.362q3.605.007,7.207,0",
    transform: "translate(0 0)",
    fill: "#6a3089"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42958",
    "data-name": "Path 42958",
    d: "M83.737,470.694q9.008,0,18.016,0a2.025,2.025,0,0,1,2.064,1.289,1.817,1.817,0,0,1-.463,2.116,2.251,2.251,0,0,1-1.679.623c-.775.014-1.55,0-2.325,0l-32.352,0c-.484,0-.971.02-1.452-.024a2.006,2.006,0,1,1,.174-4q6.538-.01,13.076,0h4.94",
    transform: "translate(-53.394 -395.754)",
    fill: "#f26e14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42959",
    "data-name": "Path 42959",
    d: "M83.76,381.764h17.82c1.441,0,2.382.759,2.411,1.937s-.882,1.991-2.33,2.059c-.483.023-.968.007-1.453.007q-16.9,0-33.8-.011a5.975,5.975,0,0,1-1.437-.138,2.032,2.032,0,0,1-1.452-2.04,2,2,0,0,1,1.936-1.808c1.807-.023,3.616-.008,5.423-.008H83.76",
    transform: "translate(-53.4 -320.98)",
    fill: "#f26e14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42960",
    "data-name": "Path 42960",
    d: "M75.656,292.8H85.835a1.828,1.828,0,0,1,1.856,1.412,1.957,1.957,0,0,1-.974,2.311,2.486,2.486,0,0,1-1.223.228q-9.839.008-19.678,0a2.065,2.065,0,0,1-2.3-1.964c-.008-1.189.922-1.986,2.354-1.989q4.9-.01,9.791,0Z",
    transform: "translate(-53.4 -246.183)",
    fill: "#f26e14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42961",
    "data-name": "Path 42961",
    d: "M405.735,381.761c1,0,2-.013,3,0a2.03,2.03,0,0,1,2.078,1.876,1.911,1.911,0,0,1-1.783,2.036,42.408,42.408,0,0,1-6.573,0,1.85,1.85,0,0,1-1.706-2.079,1.91,1.91,0,0,1,1.979-1.83c1-.017,2,0,3,0",
    transform: "translate(-336.948 -320.978)",
    fill: "#f26e14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42962",
    "data-name": "Path 42962",
    d: "M405.9,292.8c1,0,2-.026,3,.007a1.96,1.96,0,0,1,1.936,1.905,1.9,1.9,0,0,1-1.824,1.995q-3.241.085-6.486-.011a1.836,1.836,0,0,1-1.754-2.024,1.865,1.865,0,0,1,1.929-1.869c1.065-.025,2.131-.005,3.2,0",
    transform: "translate(-336.968 -246.178)",
    fill: "#f26e14"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDuplicate);
export default __webpack_public_path__ + "static/media/icon-duplicate.763ce4b67a5617d9f51a2eee2c1e69ea.svg";
export { ForwardRef as ReactComponent };